import { InputField } from 'components/molecules'
import { Label } from 'reactstrap'

const ProductAgeFilterField = () => (
  <>
    <Label className='filter-title font-weight-bold pb-2'>
      { 'AGE' }
    </Label>
    <InputField
      name='age_from'
      label='Min'
      placeholder='0'
      type='number'
      formText='Usia product terhitung dari live date sampai hari ini ( >= )'
    />
    <InputField
      name='age_to'
      label='Max'
      placeholder='120'
      type='number'
      formText='Usia product terhitung dari live date sampai hari ini ( <= )'
    />
  </>
)

export default ProductAgeFilterField
